import axios, { AxiosResponse } from "axios";
import { IUser } from "../interfaces";
import { User } from "../models";

const listEndpoint = `${process.env.REACT_APP_BASE_URL}/getByActivityTimes?`;
const searchEndpoint = `${process.env.REACT_APP_BASE_URL}/searchActivityTimes?`;

export const getList = async function (duration: string, page: number, limit: number, type: string): Promise<IUser[]> {
    const url = `${listEndpoint}duration=${duration}&page=${page}&limit=${limit}&type=${type}`;
    try {
        const response: AxiosResponse<IUser[], any> = 
        await axios(url);
      const _data: IUser[] = response.data.map((item: IUser) => new User(item))
      return _data;
    } catch (error: any) {
        throw new Error(`Error in 'axiosGetJsonData(${url})'`);
    }

};
export const search = async function (duration: string,searchParam: string): Promise<IUser[]> {
    const url = `${searchEndpoint}duration=${duration}`;
    try {
        let payload = { "searchparam" : searchParam };
        console.log('search param ' + searchParam);
        const response: AxiosResponse<IUser[], any> = await axios
          .post(url, payload);
      const _data: IUser[] = response.data.map((item: IUser) => new User(item))
      return _data;
    } catch (error: any) {
        throw new Error(`Error in 'axiosPostJsonData(${url})'`);
    }
};
